export const components = {
  MuiUseMediaQuery: {
    defaultProps: {
      noSsr: true,
    },
  },
};
